module.exports = __webpack_public_path__ + "img/open_in_new_white_24dp.214fb799.png";